"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGridNormalHeaderRenderer = void 0;
function createGridNormalHeaderRenderer() {
    return function renderGridHeader(_a) {
        var { originalRenderer } = _a, rest = __rest(_a, ["originalRenderer"]);
        if (!originalRenderer) {
            throw new Error('GridCore error: "originalRenderer" must be provided ');
        }
        return originalRenderer(Object.assign({}, rest));
    };
}
exports.createGridNormalHeaderRenderer = createGridNormalHeaderRenderer;
//# sourceMappingURL=createGridNormalHeaderRenderer.js.map